import { render, staticRenderFns } from "./DownloadColumn.vue?vue&type=template&id=0994f160&scoped=true"
import script from "./DownloadColumn.vue?vue&type=script&lang=js"
export * from "./DownloadColumn.vue?vue&type=script&lang=js"
import style0 from "./DownloadColumn.vue?vue&type=style&index=0&id=0994f160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0994f160",
  null
  
)

export default component.exports